'use client'

import { usePathname } from 'next/navigation'
import { getBazaArticleReadingSegments } from '@/app/baza/_helpers/get-baza-article-reading-segments'
import { useCollectionStructure } from '@/app/baza/(collection)/_utils/CollectionStructureContext/CollectionStructureContext'
import { ModuleSidebarAccordion } from './ModuleSidebarAccordion'

type ModuleSidebarMobileProps = {
  isLoggedIn: boolean
}

export function ModuleSidebarMobile({ isLoggedIn }: ModuleSidebarMobileProps) {
  const pathname = usePathname()
  const articleReadingSegments = getBazaArticleReadingSegments(pathname)
  const { modules, collection } = useCollectionStructure()

  if (!collection || !articleReadingSegments) {
    return null
  }

  const articleExists = modules.some(module =>
    module.articles.some(article => article.slug === articleReadingSegments.articleSlug)
  )

  if (!articleExists) {
    return null
  }

  return (
    <ModuleSidebarAccordion
      collectionSlug={articleReadingSegments.collectionSlug}
      modules={modules}
      canManageCollection={collection.canManage ?? false}
      isLoggedIn={isLoggedIn}
    />
  )
}
